/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlOnboardingActionItems } from './ControlOnboardingActionItems';
import {
    ControlOnboardingActionItemsFromJSON,
    ControlOnboardingActionItemsFromJSONTyped,
    ControlOnboardingActionItemsToJSON,
} from './ControlOnboardingActionItems';

/**
 * 
 * @export
 * @interface ControlSSOLoginResponse
 */
export interface ControlSSOLoginResponse {
    /**
     * 
     * @type {string}
     * @memberof ControlSSOLoginResponse
     */
    access_token?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlSSOLoginResponse
     */
    redirect_uri?: string;
    /**
     * 
     * @type {Array<ControlOnboardingActionItems>}
     * @memberof ControlSSOLoginResponse
     */
    onboarding_action_items?: Array<ControlOnboardingActionItems>;
    /**
     * 
     * @type {string}
     * @memberof ControlSSOLoginResponse
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlSSOLoginResponse
     */
    auth0_url?: string;
}

/**
 * Check if a given object implements the ControlSSOLoginResponse interface.
 */
export function instanceOfControlSSOLoginResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ControlSSOLoginResponseFromJSON(json: any): ControlSSOLoginResponse {
    return ControlSSOLoginResponseFromJSONTyped(json, false);
}

export function ControlSSOLoginResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlSSOLoginResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'access_token': !exists(json, 'access_token') ? undefined : json['access_token'],
        'redirect_uri': !exists(json, 'redirect_uri') ? undefined : json['redirect_uri'],
        'onboarding_action_items': !exists(json, 'onboarding_action_items') ? undefined : ((json['onboarding_action_items'] as Array<any>).map(ControlOnboardingActionItemsFromJSON)),
        'email': !exists(json, 'email') ? undefined : json['email'],
        'auth0_url': !exists(json, 'auth0_url') ? undefined : json['auth0_url'],
    };
}

export function ControlSSOLoginResponseToJSON(value?: ControlSSOLoginResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'access_token': value.access_token,
        'redirect_uri': value.redirect_uri,
        'onboarding_action_items': value.onboarding_action_items === undefined ? undefined : ((value.onboarding_action_items as Array<any>).map(ControlOnboardingActionItemsToJSON)),
        'email': value.email,
        'auth0_url': value.auth0_url,
    };
}

